import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DeleteButton, TextRow, CustomDelete, PaginationFillTable, AddCircleBlue } from 'components';
import { Images, PermissionList, RolePermission, useModal, SendPageSave, sortListByKey } from 'utils';
import { roleActions } from 'store';
import { managementFragments } from './style';
import { AddRoleModal } from './addRoleModal';

const DELETE_ACTION = 'DELETE_ROLE';
export const Role = ({ roleInfo, rolesCount, info, afterSuccess }) => {
    const { role } = useSelector((state) => ({
        role: state.roles.role,
    }));
    const classes = managementFragments();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { open } = useModal();
    const [page, setPage] = useState(1);
    const list = sortListByKey(roleInfo, 'title');

    const handleDelete = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        open(
            <CustomDelete
                text={`This action is not reversible.`}
                info="Are you sure you want to delete this role?"
                handleDel={() => dispatch(roleActions.deleteRole(item?.id))}
                actionType={DELETE_ACTION}
                afterSuccess={afterSuccess}
            />
        );
    };

    const changePage = (number) => {
        setPage(number);
        SendPageSave(number, info, navigate);
    };

    const openRolePermission = (role) => {
        dispatch(roleActions.openRole(role));
    };

    return (
        <>
            <div className={classes.tableStyle}>
                <div className={classes.roleListHeaderBox}>
                    <div className={classes.roleListHeader}>
                        <p className={classes.roleHeaderTitle}>Role</p>
                        <div>
                            <AddCircleBlue text={'Add Role'} handleClick={() => open(<AddRoleModal />)} />
                        </div>
                    </div>
                </div>
                <div className={classes.scroll}>
                    <div style={{ height: '455px', overflow: 'auto' }}>
                        {!!list?.length &&
                            list.map((item, j) => (
                                <div
                                    onClick={() => openRolePermission(item)}
                                    key={j}
                                    className={role?.id === item?.id ? classes.tableBodyBottomActive : classes.tableBodyBottom}
                                >
                                    <div className={classes.tableBodyStyle}>
                                        <div className="full-width">
                                            <img
                                                src={
                                                    role?.id === item?.id
                                                        ? Images.accessManagementOutline
                                                        : Images.accessManagementOutlineGray
                                                }
                                                alt={'accessManagementUser'}
                                            />
                                            <p className={classes.roleTitle}>
                                                <TextRow name={item?.title} />
                                            </p>
                                        </div>
                                        {RolePermission([PermissionList.ROLES_CREATE?.code]) && (
                                            <div className="flex-align-center">
                                                <button onClick={() => open(<AddRoleModal item={item} />)} className={classes.editBtn}>
                                                    <img src={Images.edit} alt="icon" />
                                                </button>

                                                <DeleteButton toolTipTitle={'Remove Role'} handleClick={(e) => handleDelete(e, item)} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                    </div>

                    <div>
                        {rolesCount > 0 && (
                            <div style={{ height: '76px' }}>
                                <PaginationFillTable
                                    hideGoTo={true}
                                    listLength={roleInfo?.length}
                                    page={page}
                                    handleReturn={(number) => changePage(number)}
                                    count={rolesCount}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
